module.exports = __webpack_public_path__ + "img/Kibe60.047bb6fc.jpg";